// extracted by mini-css-extract-plugin
export default {"monitorTitle":"monitor_monitorTitle__+6grP","titleMonitor":"monitor_titleMonitor__-8HbG","monitorContainer":"monitor_monitorContainer__NXLS0"};